<template>
    <b-container class="my-4">
        <h3>Post form</h3>
        <b-row class="mt-4">
            <b-col>
                <b-form>
                    <p v-show="error.length" style="backgroundColor: red; color: white; textAlign: center">{{ error }}</p>
                    <b-form-group>
                        <b-form-select
                            id="category"
                            v-model="newPost.category"
                            :options="options"
                        >   
                        </b-form-select>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input
                            v-model="newPost.title"
                            placeholder="Title"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        <b-form-input
                            v-model="newPost.author"
                            placeholder="author"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group>
                        <b-form-file
                            v-model="newPost.image"
                            :state="Boolean(newPost.image)"
                            placeholder="Choose a image or drop it here..."
                            drop-placeholder="Drop image here..."
                        ></b-form-file>
                            <div class="mt-3">Selected file: {{ newPost.image ? newPost.image.name : '' }}</div>
                    </b-form-group>
                    <b-form-group>
                        <vue-editor
                            :editorOptions="editorSettings"
                            v-model="newPost.body">
                        </vue-editor>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
        <div class="buttons">
            <b-button variant="outline-success" @click.prevent="sendCreatePost" :disabled="postId ? !disabledButton : disabledButton">Create</b-button>
            <b-button variant="outline-primary" @click="sendEditPost" :disabled="postId ? disabledButton : !disabledButton">Edit</b-button>
            <b-button variant="outline-danger" @click="sendDeletePost" :disabled="postId ? disabledButton : !disabledButton">Delete</b-button>
            <b-button variant="outline-secondary" to="/admin">Cancel</b-button>
        </div>
        
    </b-container>
</template>

<script>
import moment from 'moment'
import { VueEditor,Quill } from 'vue2-editor'

import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
import { 
    createPost,
    editPost,
    getPost,
    deletePost} from '../../firebase/posts'

import {getCategories } from '../../firebase/categories'

export default {
    name: 'post-form',
    data(){
        return {
            newPost: {
                title:  '',
                author:  '',
                body: '',
                image: null,
                createdAt: moment(),
                category: null,
            },
            options: [{value: null, text: "Select your category"}],
            error: '',
            editorSettings: {
                modules: {
                imageDrop: true,
                imageResize: {}
                }
            },
            postId: this.$route.params.id,
            post: [],
            disabledButton: false
        }
    },
    methods: {
        sendCreatePost() {
            if (!this.newPost.title || !this.newPost.author || !this.newPost.body || !this.newPost.image || !this.newPost.category) {
                this.error = 'Please enter title, author and body, image and category'
                console.log('error', this.error)
            } else {
                this.error = ''
                createPost(this.newPost).then(() => {
                    console.log('createdPost', this.newPost)
                    this.$router.push({ path: `/admin/${this.newPost.category}` })
                })
            }
        },
        sendEditPost() {
            editPost(this.postId, this.newPost).then(() => {
                this.$router.push({ path: `/admin/${this.newPost.category}` })
            })
        },
        sendDeletePost() {
            deletePost(this.postId).then(() => {
                this.$router.push({ path: `/admin/${this.newPost.category}` })
            })
        },
    },
    components: {
       VueEditor
    },
    created(){
        getCategories().then(categories => {
            categories.map(cat => {
                const opt = {
                    value: cat.id,
                    text: cat.name
                }
                this.options.push(opt)
            })
        })
        if(this.postId) {
            getPost(this.postId).then(post => {
                // console.log('post', this.post)
                this.newPost = post
            })
        }
        
    }
}
</script>

<style scoped>
   .buttons {
       display: flex;
       justify-content: space-between;
   }
</style>